
import genericService from '../genericService';

const urls = {
    CALCULATOR: 'tank-management/calculation',


    EXPORT_DISCHARGE: 'tank-management/tank-report-print-discharge',// (POST)
    EXPORT_TRAVASE: 'tank-management/tank-report-print-travase', // (POST)
    EXPORT_MOVEMENT: 'tank-management/tank-report-print-movement', // (POST)
    EXPORT_LEVEL: 'tank-management/tank-report-print-level', // (POST)
    PRINT: 'tank-management/tank-report-print' //(GET)
}

export default {
    async calculation(body, callback){
        await genericService.post(urls.CALCULATOR, body).then(callback);
    },
    async exportLevel(body, callback){
        await genericService.post(urls.EXPORT_LEVEL, body).then(callback);
    },
    async exportMovement(body, callback){
        await genericService.post(urls.EXPORT_MOVEMENT, body).then(callback);
    },
    async exportDischarge(body, callback){
        await genericService.post(urls.EXPORT_DISCHARGE, body).then(callback);
    },
    async print(id, callback){
        await genericService.dowloadFilePathVariable(urls.PRINT, id).then(callback);
    },
}